import React from 'react';
import { Link } from 'react-router-dom';
import AppIcon from '../ui/AppIcon';

const SignupPage = () => {
  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <AppIcon size={80} />
              <h1>Create Account</h1>
              <p>Start your mindfulness journey today</p>
            </div>
            <p>Signup functionality coming soon...</p>
            <div className="auth-footer">
              <p>
                Already have an account?{' '}
                <Link to="/login" className="auth-link">Sign In</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
